var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer",class:_vm.size},[_c('img',{staticClass:"image",attrs:{"src":_vm.imageUrl}}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }